import React from "react";
import Mike from "../../assets/img/emma-voice/mike.png";
import OnMike from "../../assets/img/emma-voice/onMike.png";
import './MovementVoice.scss';

const MovementVoice = ({isAudioPlayEnabled, onChangeAudioPlay}) => {
    const toggleBtn = (e) => {
        e.preventDefault();
        onChangeAudioPlay();
    }
    return(
        <div className="movement-voice__box">
            <button className="movement-voice__toggle-btn" onClick={(e) => toggleBtn(e)}>
                {isAudioPlayEnabled && (
                    <>
                        <span className="movement-voice__on-off-text">ON</span>
                        <i className="fa-solid fa-microphone"></i>
                    </>
                )}
                {!isAudioPlayEnabled && (
                    <>
                        <i className="fa-solid fa-microphone-slash"></i>
                        <span className="movement-voice__on-off-text">OFF</span>
                    </>
                )}
            </button>
        </div>
    )
}

export  default MovementVoice;